import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "Choose service", body: "Pick the SEO or PR service and the package that fits your goals and timeline." },
  { n: "02", title: "Submit requirements", body: "Share URLs, target keywords, business info, and the outcome you're chasing." },
  { n: "03", title: "Campaign execution", body: "Our specialists handle outreach, optimization, publishing or audits — fully white-label." },
  { n: "04", title: "Receive deliverables", body: "Live links, audit reports and performance data land directly in your dashboard." },
];

export default function HowItWorks() {
  return (
    <section className="py-24 sm:py-32 bg-surfaceAlt/60 border-y border-line" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14 items-end">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-4">How it works</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">A clean ordering flow your team won't fight.</h2>
          </div>
          <div className="lg:col-span-6 lg:pl-8">
            <p className="text-inkSoft leading-relaxed">No back-and-forth threads. No spreadsheet chaos. Place orders, track status, and pull reports in minutes — built around how agencies and in-house teams actually work.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.55, ease: [0.25, 1, 0.5, 1] }}
              className="card-soft p-6 relative"
            >
              <div className="font-mono text-xs text-inkSoft tracking-widest mb-6">STEP {s.n}</div>
              <div className="font-display text-2xl font-semibold tracking-tight mb-2">{s.title}</div>
              <div className="text-sm text-inkSoft leading-relaxed">{s.body}</div>
              <div className="absolute top-5 right-5 font-mono text-5xl text-terra/20 font-bold tracking-tighter">{s.n}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
